module.exports = __webpack_public_path__ + "static/media/mc_eject_rotor.f1aaacd9.svg";